import { IMPORT_DOCUMENT_FIELDS_GROUPS } from '../../../constants/importDocuments';

// eslint-disable-next-line no-shadow
function getGroupName(key, groups) {
  return (
    Object.entries(groups).find(([, keys]) => keys.includes(key))?.[0] || null
  );
}

function isGroupped(firstKeyPart) {
  return Object.values(IMPORT_DOCUMENT_FIELDS_GROUPS).some((group) =>
    Object.keys(group).includes(firstKeyPart)
  );
}

function addGroupNotices(groupedResult) {
  const groupedResultWithNotices = JSON.parse(JSON.stringify(groupedResult));

  const groupNotices = [
    { key: 'Lender', notice: 'No lender detected' },
    { key: 'Borrower', notice: 'No borrower detected' },
    { key: 'Coborrower', notice: 'No coborrower detected' },
  ];

  groupNotices.forEach(({ key, notice }) => {
    if (
      !groupedResult[key] ||
      Object.keys(groupedResult[key]).length === 0 ||
      Object.values(groupedResult[key])?.every?.((value) => !value)
    ) {
      groupedResultWithNotices[key] = { Notice: notice };
    }
  });

  return groupedResultWithNotices;
}

function appendUnsortedKeys(
  unsortedResult,
  sortedGroupedResult,
  excludedArrayKeys
) {
  Object.keys(unsortedResult).forEach((key) => {
    if (!sortedGroupedResult[key] && !excludedArrayKeys.includes(key)) {
      // eslint-disable-next-line no-param-reassign
      sortedGroupedResult[key] = unsortedResult[key];
    } else if (
      typeof unsortedResult[key] === 'object' &&
      unsortedResult[key] !== null &&
      !excludedArrayKeys.includes(key)
    ) {
      // eslint-disable-next-line no-param-reassign
      appendUnsortedKeys(
        unsortedResult[key],
        sortedGroupedResult[key],
        excludedArrayKeys
      );
    }
  });

  return sortedGroupedResult;
}

function sortGroupedResult(unsortedResult, groups) {
  const sortedGroupedResult = {};
  const excludedArrayKeys = [];

  // Sort the grouped result based on the order of keys in IMPORT_DOCUMENT_FIELDS_GROUPS
  Object.keys(groups).forEach((key) => {
    if (unsortedResult[key]) {
      sortedGroupedResult[key] = {};

      groups[key].forEach((subKey) => {
        if (Array.isArray(subKey)) {
          const [subKeyName, subKeyValues] = subKey;
          excludedArrayKeys.push(subKeyName);

          sortedGroupedResult[key][subKeyName] = sortGroupedResult(
            { [subKeyName]: unsortedResult[subKeyName] },
            { [subKeyName]: subKeyValues }
          )[subKeyName];
        } else if (unsortedResult[key][subKey]) {
          sortedGroupedResult[key][subKey] = unsortedResult[key][subKey];
        }
      });
    }
  });

  // Append keys that were not included in any group.
  appendUnsortedKeys(unsortedResult, sortedGroupedResult, excludedArrayKeys);

  return sortedGroupedResult;
}

export function groupResultFields(result, type) {
  if (!result) {
    return {};
  }

  const groups = IMPORT_DOCUMENT_FIELDS_GROUPS[type];

  if (!groups) {
    return result;
  }

  const groupsCopy = JSON.parse(JSON.stringify(groups));

  if (result.rate_type !== 'adjustable') {
    delete groupsCopy['ARM Terms'];
  }

  const groupedResult = {};

  Object.keys(result).forEach((key) => {
    const groupName = getGroupName(key, groupsCopy);

    if (groupName) {
      if (!groupedResult[groupName]) {
        groupedResult[groupName] = {};
      }

      groupedResult[groupName][key] = result[key];
    } else {
      groupedResult[key] = result[key];
    }
  });

  const sortedGroupedResult = sortGroupedResult(
    groupedResult,
    JSON.parse(JSON.stringify(groups))
  );

  if (type !== 'NOTE') {
    return sortedGroupedResult;
  }

  const groupedResultWithNotices = addGroupNotices(sortedGroupedResult);

  return groupedResultWithNotices;
}

export function removeGroupFromField(key) {
  const keyParts = key.split('.');

  if (keyParts.length > 1 && isGroupped(keyParts[0])) {
    return keyParts.slice(1).join('.');
  }

  return key;
}
